export const create = {
  createSuccessfully: 'Create new announcement successfully!',
}
